import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
//import Calendar from '@/components/calendar/Calendar'
//import Videos from '@/components/videos/Videos'
//import Documents from '@/components/documents/Documents';
//import DocSearch from '@/components/documents/DocSearch';
//import DocCalendar from '@/components/documents/DocCalendar';

//import Photos from '@/components/photos/Photos'

import Issues from '@/components/issues/Issues';
import Issues2 from '@/components/issues/Issues2';

import IssuesHistory from '@/components/issues/IssuesHistory';

import Users from '@/components/users/Users';
import Solutions from '@/components/masterfiles/Solutions';
import Diagnostics from '@/components/masterfiles/Diagnostics';
import DiagnosticTypes from '@/components/masterfiles/DiagnosticTypes';
import SolutionTypes from '@/components/masterfiles/SolutionTypes';
import IssuesMaster from '@/components/masterfiles/IssuesMaster';
import IssueTypes from '@/components/masterfiles/IssueTypes';
import IssueSubtypes from '@/components/masterfiles/IssueSubtypes';
import Locations from '@/components/masterfiles/Locations';
import Departments from '@/components/masterfiles/Departments'
import Sections from '@/components/masterfiles/Sections'
import Assignees from '@/components/users/Assignees'
import IssueStatus from '@/components/masterfiles/IssueStatus';
import ProblemSources from '@/components/masterfiles/ProblemSources';
import AccountablePersons from '@/components/masterfiles/AccountablePersons';

import Populate from '@/components/masterfiles/Populate';
//import GSTCTest from '@/components/projects/GSTCTest';
//import GanttChart from '@/components/projects/GanttChart';


import UpdateMasterfiles from '@/components/masterfiles/UpdateMasterfiles'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { disallowAuthed: true }
    },
    {
        path: '/users',
        name: 'Users',
        component: Users
    },
    {
        path: '/issues',
        name: 'Issues',
        component: Issues
    },
    {
      path: '/issues2',
      name: 'Issues2',
      component: Issues2
  },
  {
      path: '/issueshistory',
      name: 'IssuesHistory',
      component: IssuesHistory
  },
  {
      path: '/issuesMaster',
      name: 'Issues Master',
      component: IssuesMaster
    },
    {
      path: '/issueTypes',
      name: 'Issue Types',
      component: IssueTypes
    },
    {
      path: '/issueSubtypes',
      name: 'Issue Subtypes',
      component: IssueSubtypes
    },
    {
        path: '/solutions',
        name: 'Solutions',
        component: Solutions
    },
    {
      path: '/diagnostics',
      name: 'Diagnostics',
      component: Diagnostics
    },
    {
      path: '/diagnosticTypes',
      name: 'Diagnostic Types',
      component: DiagnosticTypes
    },
    {
      path: '/solutionTypes',
      name: 'Solution Types',
      component: SolutionTypes
    },
    {
      path: '/locations',
      name: 'Locations',
      component: Locations
    },
    {
      path: '/departments',
      name: 'Departments',
      component: Departments
    },
    {
      path: '/sections',
      name: 'Sections',
      component: Sections
    },
    {
      path: '/assignees',
      name: 'Assignees',
      component: Assignees
    },
    {
        path: '/populate',
        name: 'Populate',
        component: Populate
    },
    {
      path: '/issue-status',
      name: 'IssueStatus',
      component: IssueStatus
  },
  {
    path: '/problem-sources',
    name: 'ProblemSources',
    component: ProblemSources
},
{
  path: '/accountable-persons',
  name: 'AccountablePersons',
  component: AccountablePersons
},
{
      path: '/update-master',
      name: 'UpdateMasterfiles',
      component: UpdateMasterfiles
  },

  ]
})
